<template lang="pug">
  section.quadro-botoes
    .card
      .card-body
        .botoes-container
          .botao(
            v-for="botao in botoes"
            :key="botao.id"
            @click="botao.quantidade > 0 ? abrirModal(botao) : null"
            :class="{ 'desabilitado': botao.quantidade === 0, 'ativo': botao.quantidade > 0 }"
            )
            .icone-circulo
              i(:class="botao.icone") <!-- Ícone dentro do círculo -->
            .conteudo
              h3 {{ botao.label }}
            .notificacao(v-if="botao.quantidade > 0")
              span {{ botao.quantidade }}

      modal-propostas-component(
        :visible="modalVisible"
        :title="modalTitulo"
        :tipoAlerta="modalTipoAlerta"
        :municipios="dadosModal"
        @close="modalVisible = false"
        @updateAlert="handleAlertUpdate"
      )
</template>

<script>

//import { ref, onMounted } from 'vue'
import ModalPropostasComponent from "@/views/paginaInicial/components/ModalPropostas.vue";
import { alertNaolidos, novasPropostasEnviadas, propostasAguardandoValidacao, termoAguardandoAssinatura, termoAssinado, propostaEmAnalise, imoveisAguardandoSuspensao } from '@/services/processo.service';

export default {
  components: { ModalPropostasComponent },
  name: 'DashBoard',
  data() {
    return {
      botoes: [],
      atualiza: false,
      modalVisible: false,
      modalTitulo: "",
      modalTipoAlerta: 0,
      dadosModal: [],
    };
  },
  async mounted() {
    try {

      const response = await alertNaolidos();
      if (response.status == 200) {
        this.botoes = await response.data;
      } else {
        console.error('Erro ao buscar dados:', response.statusText);
      }
    } catch (error) {
      console.error('Erro ao conectar à API:', error);
    }
  },
  methods: {
    async handleAlertUpdate(newAlertState) {
        try {
                    const response = await alertNaolidos();
                    if (response.status == 200) {
                    this.botoes = await response.data;
                    } else {
                    console.error('Erro ao buscar dados:', response.statusText);
                    }
                    } catch (error) {
                    console.error('Erro ao conectar à API:', error);
                    }
    },
    close(status) {

      alert('fechando modal');
    },
    abrirModal(botao) {
      this.modalTitulo = `${botao.label}`;
      this.modalVisible = true;
      this.modalTipoAlerta = botao.id;
      this.fetchDados(botao.id);
    },
    fetchDados(botaoId) {
      const actions = {
        1: () => this.novasPropostas(),
        2: () => this.aguardandoValidacao(),
        3: () => this.aguardandoAssinatura(),
        4: () => this.termosassinado(),
        5: () => this.propostaAnalise(),
        6: () => this.buscarImoveisAguardandoSuspensao(),
        default: () => alert('Botão Selecionado não disponivel! tente mais tarde')
      };

      (actions[botaoId] || actions.default)();

    },
    novasPropostas() {
      this.dadosModal = [];
      novasPropostasEnviadas()
        .then((response) => {
          this.dadosModal = response.data;

        })
        .catch((error) => console.error("Erro ao buscar dados:", error));
    },
    aguardandoValidacao() {
      this.dadosModal = [];
      propostasAguardandoValidacao()
        .then((response) => {
          this.dadosModal = response.data;

        })
        .catch((error) => console.error("Erro ao buscar dados:", error));
    },
    aguardandoAssinatura() {
      this.dadosModal = [];
      termoAguardandoAssinatura()
        .then((response) => {
          this.dadosModal = response.data;

        })
        .catch((error) => console.error("Erro ao buscar dados:", error));
    },
    termosassinado() {
      this.dadosModal = [];
      termoAssinado()
        .then((response) => {
          this.dadosModal = response.data;
        })
        .catch((error) => console.error("Erro ao buscar dados:", error));
    },
    propostaAnalise() {
      this.dadosModal = [];
      propostaEmAnalise()
        .then((response) => {
          this.dadosModal = response.data;
        })
        .catch((error) => console.error("Erro ao buscar dados:", error));
    },
    buscarImoveisAguardandoSuspensao() {
      this.dadosModal = [];
      imoveisAguardandoSuspensao()
        .then((response) => {
          this.dadosModal = response.data;
        })
        .catch((error) => console.error("Erro ao buscar dados:", error));
    },
  },
};
</script>

<style lang="scss">
.quadro-botoes {
  margin: 0px;

  .card {
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    padding: 0px 20px;


    .card-body {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      padding: 15px;

      .botoes-container {
        display: flex;
        justify-content: space-evenly;
        gap: 20px;
        flex-wrap: wrap;
        width: 100%;

        .ativo {
            background-color: #4caf50 !important;
            color: white !important;
        }

        .desabilitado{
            background-color: #ccc !important;
            color: #666 !important;
            pointer-events: none;
            cursor: not-allowed;
            opacity: 0.7;
        }
      }

      .botao {
        padding: 10px 5px;
        border-radius: 8px;
        width: 100px;
        text-align: center;
        cursor: pointer;
        position: relative;
        /* Necessário para posicionar a notificação */
        transition: transform 0.2s ease;

        flex-grow: 0;
        flex-shrink: 0;

        &:hover {
          transform: scale(1.05);
        }

        .icone-circulo {
          background-color: white;
          border-radius: 50%;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 10px auto;
        }

        i {
          font-size: 24px;
          color: #4caf50;
        }

        .conteudo h3 {
          font-size: 12px;
          margin: 0;
        }

        .notificacao {
          position: absolute;
          top: -5px;
          right: -10px;
          background-color: red;
          color: white;
          font-size: 12px;
          font-weight: bold;
          border-radius: 50%;
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px solid white;
        }




      }
    }
  }
}

.el-dialog {
  max-height: 90vh;
  border-radius: 10px;
  overflow: hidden;
}

el-dialog__header {
  border-bottom: 2px solid green;
  padding-bottom: 6px;
  box-sizing: border-box;
}

.el-dialog__title {
  color: rgb(1, 132, 1);
  font-weight: bold;
  padding-bottom: 8px;
  margin: 0;
}
</style>
